// extracted by mini-css-extract-plugin
export default {"toast":"toast_toast__ZPf9F","textContainer":"toast_textContainer__2Y8Ne","title":"toast_title__zl2LJ","description":"toast_description__5n2LS","close":"toast_close__7vP4B"};